import { render, staticRenderFns } from "./dev-list.vue?vue&type=template&id=68c5e64c&scoped=true"
import script from "./dev-list.vue?vue&type=script&lang=js"
export * from "./dev-list.vue?vue&type=script&lang=js"
import style0 from "./dev-list.vue?vue&type=style&index=0&id=68c5e64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c5e64c",
  null
  
)

export default component.exports